document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-variant-picker').forEach(function (picker) {
    var productForm = document.getElementById(picker.getAttribute('data-product-form-id'));
    var variantIdInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    var activeOption = picker.querySelector('.custom-variant-picker-box-splitter.active');

    if (variantIdInput && activeOption && activeOption.dataset.variantId) {
      variantIdInput.value = activeOption.dataset.variantId;
    }
  });
});
